import { create, StateCreator } from 'zustand';

interface ErrorState {
  error: string | null;
  setError: (error: string | null) => void;
  clearError: () => void;
}

const errorMiddleware = (config: StateCreator<ErrorState>): StateCreator<ErrorState> =>
  (set, get, api) =>
    config((partial) => {
      if ((partial as Partial<ErrorState>).error) {
        console.error((partial as Partial<ErrorState>).error);
      }
      set(partial);
    }, get, api);

export const useErrorStore = create<ErrorState>(
  errorMiddleware((set) => ({
    error: null,
    setError: (error) => set({ error }),
    clearError: () => set({ error: null }),
  }))
);
